import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Configurazione } from '../../../../shared/interface';

@Component({
  selector: 'app-modifica-configurazione-backoffice',
  templateUrl: './modifica-configurazione-backoffice.component.html',
  styleUrl: './modifica-configurazione-backoffice.component.css'
})
export class ModificaConfigurazioneBackofficeComponent implements OnInit {

  @ViewChild("confirmDeletePopupRef") confirmPopup!: ConfirmPopup;

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute, private confirmationService: ConfirmationService) { }  

  formConfigurazione!: FormGroup;  

  configurazione?: Configurazione;

  ngOnInit(): void {    

    this.formConfigurazione = new FormGroup({
      value: new FormControl(null, Validators.required),      
      descrizione: new FormControl(null),        
    })

    this.route.params.subscribe(params => {
      const id = params['id'];

      this.apiService.getConfigurazione(id).subscribe({
        next: (data) => this.configurazione = data,
        error: (err) => this.router.navigate(['/backoffice/configurazioni']),
        complete: () => {

          this.formConfigurazione.patchValue({
            value: this.configurazione?.value,            
            descrizione: this.configurazione?.descrizione,            
          })

        }
      })

    })
  }

  onDeleteConfigurazionePopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare la configurazione?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteConfigurazione(this.configurazione!.id).subscribe({
          next: (data) => this.apiService.setConfigurazioni(),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.router.navigate(['/backoffice/configurazioni']);
            this.apiService.message("success", "Eliminazione", "La configurazione è stata eliminata con successo")
          }
        })
      }
    });
  }

  onDelete() {
    this.confirmPopup.accept();
  }

  onAnnulla() {
    this.confirmPopup.reject();
  }

  onSubmit() {

    const configurazione = {
      value: this.formConfigurazione.get('value')?.value,
      descrizione: this.formConfigurazione.get('descrizione')?.value
    }

    this.apiService.updateConfigurazione(configurazione, this.configurazione!.id).subscribe({
      next: (data) => this.apiService.setConfigurazioni(),        
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/configurazioni'])
        this.apiService.message('success', 'Modifica', "Modifica effettuata con successo!")
      }
    })

  }


}
